import {ReviewDisplayInfo} from "../components/ReviewCarousel/ReviewCarousel";

export const carouselReviews: ReviewDisplayInfo[] = [
    {
        id: "355e75b3-6970-4c9b-8b14-f21d33baf790",
        rating: 5,
        description:
            '"1st Financial Bank USA allowed me to get my first credit card and I’m very thankful!"',
        dateOfReview: "John, January 2021",
    },
    {
        id: "80e88d59-3b45-4075-b50a-023bdd132b7d",
        rating: 5,
        description: '"Easy questions and took no time for me to apply!"',
        dateOfReview: "Stephanie, May 2021",
    },
    {
        id: "e7748eb9-c806-437a-8481-848214f223ff",
        rating: 5,
        description: '"I was able to get approved and can\'t wait to start fresh for college."',
        dateOfReview: "Malcolm, June 2021",
    },
    {
        id: "80e88d59-12ad-4075-b50a-023bdd132b7d",
        rating: 5,
        description: '"This process was easy to apply for my first credit card"',
        dateOfReview: "Dakarai, June 2021",
    },
];
